/*
export default function hasPermission({ to, from, next, store }) {
  const user = store.getters.getLoginInProfile;
  const permission = to.meta.permission;

  if (!permission) return next();

  const userPermissions = user?.empPermissions?.map(p => p.name) || [];
  //console.log(user,userPermissions,'userPermissions');
  if (user.type ==='MANAGER' || (user.type ==='EMPLOYEE' && user.managerAccess ==='yes'))  {
    if((user.type ==='EMPLOYEE' && user.managerAccess ==='yes' )){
      if(userPermissions.includes(permission)){
        return next();
      }
    }else{
      return next();
    }


  } else {
    console.warn(`Missing permission: ${permission}`);
    return next({ name: 'pageNotFound' });
  }
}
*/
export default function hasPermission({ to, from, next, store }) {

  const user = store.getters.getUser;
  const permission = to.meta.permission;
  console.log(user.type);
  if (!permission) return next();
  const userPermissions = user?.empPermissions?.map(p => p.name) || [];

  // ✅ Manager → Full access
  if (user.type === 'MANAGER') {
    return next();
  }

  // ✅ EMPLOYEE with manager access
  if (user.type === 'EMPLOYEE' && user.managerAccess === 'yes') {

    const hasAHRRole = user.jobRoles?.some(role => {
      return role.get_job_roles?.name === 'Assistant Manager';
    });
    console.log(permission,user);
    if (hasAHRRole) {
      // ✅ Check permission
      if (userPermissions.includes(permission)) {
        return next();
      } else {
        console.warn(`Missing permission for AHR role: ${permission}`);
        return next({ name: 'pageNotFound' });
      }
    } else {
      // ❌ Not AHR role → Full access
      return next();
    }
  }

  // ❌ Normal employee → No access unless permission exists
  if (userPermissions.includes(permission)) {
    return next();
  }

  console.warn(`Access denied: ${permission}`);
  return next({ name: 'pageNotFound' });
}
